import React, { useState } from 'react';
import PageHeader from '../components/ui/PageHeader';
import SectionHeading from '../components/ui/SectionHeading';
import { faqs } from '../data/content';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiChevronDown } from 'react-icons/fi';

const AccordionItem = ({ faq, isOpen, onClick }) => {
  return (
    <div className="border-b border-veloura-primary/40 last:border-0">
      <button 
        className="w-full py-6 flex justify-between items-center text-left focus:outline-none"
        onClick={onClick}
      >
        <span className="font-serif text-xl text-veloura-text pr-8">{faq.q}</span>
        <SafeIcon 
          icon={FiChevronDown} 
          className={`w-6 h-6 text-veloura-accent transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} 
        />
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <p className="pb-6 text-veloura-muted leading-relaxed">
              {faq.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="bg-veloura-bg min-h-screen">
      <PageHeader title="Client FAQ" bgImage="https://images.unsplash.com/photo-1599305090598-fe179d501227?auto=format&fit=crop&q=80&w=2000" />
      
      <div className="container mx-auto px-6 max-w-3xl py-24">
        <SectionHeading title="Questions & Answers" subtitle="Everything You Need to Know" />
        
        <div className="bg-white rounded-[2rem] p-8 md:p-12 shadow-sm border border-veloura-primary/20">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              faq={faq} 
              isOpen={openIndex === index} 
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)} 
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;